import React, { useState } from "react";

// components imports
import BlogsTable from "../../../../../Components/BoltTable/BoltTable";
import BlogDetails from "./Components/BlogDetails/BlogDetails";
import UpdateBlog from "./Components/AddBlog/UpdateBlog";
import Confirm from "../../../../../Components/Popups/Confirm";
import AddBlog from "../Blogs/Components/AddBlog/AddBlog";
import Tooltip from "../../../../../Components/Tooltip/Tooltip";
import SwitchButton from "../../../../../Components/SwitchButton/SwitchButton";
import BoltButton from "../../../../../Components/UI/Buttons/BoltButton";
// apis imports
import {
  fetchAllBlogs,
  deleteBlog,
  updateBlogStatus,
} from "../../../../../services/admin.services";
// library imports
import { FcPlus } from "react-icons/fc";
import { FaRegEdit } from "react-icons/fa";
import noImage from "../../../../../assets/images/noImage.png";
import { MdRemoveRedEye, MdOutlineCancel } from "react-icons/md";
import { useTranslation } from "react-i18next";

const Blogs = ({ setSnack }) => {
  const { t } = useTranslation("admin");
  const [statusUpdating, setStatusUpdating] = useState();

  const [activeBlogs, setActiveBlogs] = useState(0);
  const [blogs, setBlogs] = useState([]);

  const [blogDetailsModal, setBlogDetailsModal] = useState();
  const [updateBlogModal, setUpdateBlogModal] = useState();
  const [confirmBox, setConfirmBox] = useState();
  const [addBlogModal, setAddBlogModal] = useState();
  const [refresh, setRefresh] = useState();
  const [loader, setloader] = useState();

  const columns = [
    {
      id: 1,
      label: t("newsletter.image"),
      render: (row) => (
        <>
          <img
            src={row?.thumb_img ?? noImage}
            onError={(e) => {
              e.target.src = noImage;
            }}
          />
        </>
      ),
      width: "200px",
    },
    {
      id: 2,
      label: t("newsletter.title"),
      render: (row) => <>{row?.title ?? "-"}</>,
      width: "200px",
    },
    {
      id: 3,
      label: t("newsletter.slug"),
      render: (row) => <>{row?.slug ?? "-"}</>,
      width: "200px",
    },
    {
      id: 4,
      label: t("newsletter.active"),
      render: (row) => (
        <>
          <SwitchButton
            onChange={(e) => handleStatusChange(e, row)}
            checked={[true, "true", "1"].includes(row.is_approved)}
            disabled={statusUpdating}
          />
        </>
      ),
      width: "200px",
    },
    {
      id: 5,
      label: t("newsletter.body"),
      render: (row) => <>{row?.body ?? "-"}</>,
      width: "300px",
    },
    {
      id: 6,
      label: t("newsletter.action"),
      render: (row) => (
        <>
          <div className="table_action__wrap">
            <Tooltip title={t("newsletter.viewDetails")}>
              <div
                className="table_action__btn"
                onClick={() => setBlogDetailsModal(row)}
              >
                <MdRemoveRedEye size={10} />
                {t("newsletter.view")}
              </div>
            </Tooltip>
            <Tooltip title={t("newsletter.editBlogDetails")}>
              <div
                className="table_action__btn"
                onClick={() => setUpdateBlogModal(row)}
              >
                <FaRegEdit size={10} />
                {t("common:actions.edit")}
              </div>
            </Tooltip>
            <Tooltip title={t("newsletter.deleteBlog")}>
              <div
                className="table_action__btn"
                onClick={() => setConfirmBox(row)}
              >
                <MdOutlineCancel size={10} />
                {t("common:actions.delete")}
              </div>
            </Tooltip>
          </div>
        </>
      ),
      width: "300px",
    },
  ];

  const fetchBlogs = async (page, perPage, filter) => {
    const response = await fetchAllBlogs(page, perPage, filter);
    if (!response.error) {
      setBlogs(response?.data?.result?.blog);
      setActiveBlogs(response?.data?.result?.count ?? 0);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
  };

  const handleDeleteBlog = async (blog) => {
    setloader(true);
    let id = blog.id;
    const deleted = await deleteBlog(id);
    if (deleted.error) {
      setloader(false);
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("newsletter.couldntDeleteThisBlog"),
          severity: "error",
        };
      });
    } else {
      setActiveBlogs(
        [true, "true", "1"].includes(blog?.is_approved)
          ? activeBlogs - 1
          : activeBlogs,
      );
      setBlogs((prevBlogs) => {
        return {
          ...prevBlogs,
          data: prevBlogs?.data.filter((item) => item.id !== id),
        };
      });
      setloader(false);
      setConfirmBox(false);
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("newsletter.blogDeletedSuccessfully"),
          severity: "success",
        };
      });
    }
  };

  const handleStatusChange = async (e, record) => {
    setStatusUpdating(true);

    const updated = await updateBlogStatus({
      id: parseInt(record.id),
      is_approved: e.target.checked,
    });

    if (updated.error) {
      setStatusUpdating(false);
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: updated.error.message,
          severity: "error",
        };
      });
    } else {
      setStatusUpdating(false);
      setActiveBlogs(updated?.data?.result?.count);
      setBlogs((prevBlogs) => {
        return {
          ...prevBlogs,
          data: prevBlogs?.data.map((item) =>
            item.id === record.id
              ? {
                  ...item,
                  is_approved: [true, "true", "1"]?.includes(
                    updated?.data?.result?.blog?.is_approved,
                  ),
                }
              : item,
          ),
        };
      });
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: [true, "true", "1"].includes(
            updated?.data?.result?.blog?.is_approved,
          )
            ? t("newsletter.blogStatusActive")
            : t("newsletter.blogStatusInactive"),
          severity: [true, "true", "1"].includes(
            updated?.data?.result?.blog?.is_approved,
          )
            ? "success"
            : "info",
        };
      });
    }
  };
  return (
    <>
      <BlogDetails
        open={!!blogDetailsModal}
        blogData={blogDetailsModal}
        setOpen={setBlogDetailsModal}
      />
      <UpdateBlog
        open={!!updateBlogModal}
        blogData={updateBlogModal}
        setOpen={setUpdateBlogModal}
        setBlogs={setBlogs}
        setSnack={setSnack}
      />
      <Confirm
        open={confirmBox}
        setOpen={setConfirmBox}
        handleConfirm={() => {
          handleDeleteBlog(confirmBox);
        }}
        loader={loader}
      />
      <AddBlog
        open={addBlogModal}
        setOpen={setAddBlogModal}
        setRefresh={setRefresh}
        setSnack={setSnack}
      />
      <div className="custom__table_size1 actionbtn__needtobe_fixwidth">
        <BlogsTable
          tableTitle={t("newsletter.blogsTitle")}
          tableId="blogsTableForAdmin"
          message={t("newsletter.noBlogsAvailableToDisplay")}
          searchPlaceHolder={t("newsletter.searchBlogs")}
          columns={columns}
          data={blogs}
          getAllData={fetchBlogs}
          refresh={refresh}
          headerButtons={
            <div className="flex gap-1.5 flex-wrap">
              <div
                className={`
                  flex items-center justify-center gap-2
                  px-2 min-h-[30px] min-w-fit
                  rounded-lg border shadow-sm
                  bg-ui-surface-sunken
                `}
              >
                <span
                  className="
                    font-medium
                    text-[11px]
                    3xl:text-xs
                    4xl:text-sm
                    text-ui-text
                  "
                >
                  {t("newsletter.activeBlogsLabel")}
                  <b> {activeBlogs}</b>
                </span>
              </div>
              <BoltButton
                icon={FcPlus}
                label={t("newsletter.addBlog")}
                onClick={() => setAddBlogModal(true)}
                variant="success"
                size="sm"
              />
            </div>
          }
        />
      </div>
    </>
  );
};

export default Blogs;
